import React, { Component } from 'react';
import Api from '../../../Global/Modules/Api';
class KennisOverzichtContent extends Component {
    constructor() {
        super();
        this.state = {
            Description: ''
        }
    }

    rawMarkup() {
        var rawMarkup = this.state.Description
        return { __html: rawMarkup };
    }

    componentDidMount() {
        const FETCH_URL = 'api/pages/permanenteducation';
        Api.GetApi(FETCH_URL).then(data => {
            this.setState({ Description: data.description })
        });
    }
    render() {
        return (
            <div>
                <h5 id="toelichting"><strong>Toelichting invoer kennisgegevens</strong></h5>
                <p dangerouslySetInnerHTML={this.rawMarkup()} />
            </div>
        );
    }
}

export default KennisOverzichtContent;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Kennis/KennisOverzichtContent.js